import { render, staticRenderFns } from "./LgStatusCard.vue?vue&type=template&id=c14d590c&scoped=true"
import script from "./LgStatusCard.vue?vue&type=script&lang=js"
export * from "./LgStatusCard.vue?vue&type=script&lang=js"
import style0 from "./LgStatusCard.vue?vue&type=style&index=0&id=c14d590c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14d590c",
  null
  
)

export default component.exports